import { render, staticRenderFns } from "./Countdown.vue?vue&type=template&id=3956b528"
import script from "./Countdown.vue?vue&type=script&lang=js"
export * from "./Countdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports